export class ProductAddedEvent extends Event {
  static type = 'product-added' as const
  basketCount: number
  itemId: number | undefined
  addedQuantity: number | undefined

  constructor(basketCount: number, itemId?: number, addedQuantity?: number) {
    super(ProductAddedEvent.type, { bubbles: true, composed: true })
    this.basketCount = basketCount
    this.itemId = itemId
    this.addedQuantity = addedQuantity
  }
}

declare global {
  interface GlobalEventHandlersEventMap {
    [ProductAddedEvent.type]: ProductAddedEvent,
  }
}
